import dayjs, { dateDisplayFormat } from '~libs/dayjs';

import { Column } from '~components/table-view';

export const bulkSahAssignColumns: Column[] = [
  {
    id: 'reference',
    header: 'Reference',
    type: 'text',
  },
  {
    id: 'full_name',
    header: 'Client',
    type: 'text',
    deriveValue: (row) => row.client?.full_name,
  },
  {
    id: 'dates',
    header: 'Budget Dates',
    type: 'text',
    deriveValue: (row: any) => {
      const start = row.start_date ? dayjs(row.start_date).format(dateDisplayFormat) : '—';
      const end = row.end_date ? dayjs(row.end_date).format(dateDisplayFormat) : '—';
      return `${start} – ${end}`;
    },
  },
  {
    id: 'status',
    header: 'Status',
    type: 'text',
    deriveValue: (row) => row.status?.name,
  },
  {
    id: 'funding_type',
    header: 'Funding Type',
    type: 'text',
    deriveValue: (row) => row.package_fixed?.funding_type?.name,
  },
];
